/*global Modernizr */
/*jslint browser:true */

(function() {
  'use strict';

  var main_menu = document.querySelector('.nav-container');

  if(main_menu) {
    var has_children = main_menu.querySelectorAll('.menu-item-has-children');

    if(has_children) {
      document.querySelector('body').addEventListener('touchstart', (e) => {
        var open_items = main_menu.querySelectorAll('.menu-item.open');

        if(open_items) {
          open_items.forEach((open_item) => {
            var anchor_container = open_item.firstElementChild,
                menu_item_link = anchor_container.firstElementChild,
                menu_item_button = menu_item_link.nextElementSibling,
                dropdown = open_item.querySelector(':scope > .sub-menu-container');


            open_item.classList.remove('open');
            menu_item_button.setAttribute('aria-expanded', 'false');

            if(dropdown) {
              dropdown.style.maxHeight = null;
            }
          });
        }
      });

      has_children.forEach((menu_item) => {
        var anchor_container = menu_item.firstElementChild,
            menu_item_link = anchor_container.firstElementChild,
            menu_item_button = menu_item_link.nextElementSibling,
            sub_menu_container = menu_item.querySelector(':scope > .sub-menu-container'),
            menu_item_list = sub_menu_container.querySelector('ul'),
            timer;

        if(menu_item_list) {
          // Don't send touch event further than the link
          menu_item_link.addEventListener('touchstart', (e) => {
            e.stopPropagation();
          }, { passive: true });

          // Allow top level nav to open sub nav on mobile
          menu_item_link.addEventListener('click', (e) => {
            var dropdown = menu_item.querySelector(':scope > .sub-menu-container');

            if(document.body.classList.contains('mobile-menu-open')) {
              e.stopPropagation();
              e.preventDefault();

              if(menu_item.classList.contains('open')) {
                menu_item.classList.remove('open');
                main_menu.classList.remove('sub-open');

                if(dropdown) {
                  dropdown.style.maxHeight = null;
                }
              } else {
                menu_item.classList.add('open');
                main_menu.classList.add('sub-open');

                if(dropdown) {
                  dropdown.style.maxHeight = dropdown.scrollHeight + "px";
                }
              }
            } else if(menu_item_link.nodeName === 'BUTTON') {
              if(menu_item.classList.contains('open')) {
                menu_item.classList.add('open');
                menu_item_button.setAttribute('aria-expanded', 'false');
                main_menu.classList.add('sub-open');
              } else {
                menu_item.classList.add('open');
                menu_item_button.setAttribute('aria-expanded', 'true');
                main_menu.classList.add('sub-open');

                setTimeout(function(){
                  var anchors = menu_item.querySelector('.sub-menu-container').querySelectorAll('ul a'),
                      select_anchor = anchors[0];

                  if(select_anchor.parentNode.classList.contains('menu-item-overview')) {
                    select_anchor = anchors[1];
                  }

                  if(select_anchor) {
                    select_anchor.focus();
                  } else {
                    menu_item.querySelector('.sub-menu-container').focus();
                  }
                }, 350);
              }
            }
          });

          if(menu_item_button) {
            // Set aria expanded on mouse enter
            menu_item.addEventListener('mouseenter', (e) => {
              menu_item_button.setAttribute('aria-expanded', 'true');
            });

            // Remove aria expanded on mouse out
            menu_item.addEventListener('mouseleave', (e) => {
              menu_item_button.setAttribute('aria-expanded', 'false');
            });

            menu_item_button.addEventListener('touchstart', (e) => {
              e.stopPropagation();

              if(e.cancelable) {
                e.preventDefault();

                var dropdown = menu_item.querySelector(':scope > .sub-menu-container');

                if(menu_item.classList.contains('open')) {
                  menu_item.classList.remove('open');
                  menu_item_button.setAttribute('aria-expanded', 'false');

                  if(dropdown) {
                    dropdown.style.maxHeight = null;
                  }
                } else {
                  menu_item.classList.add('open');
                  menu_item_button.setAttribute('aria-expanded', 'true');

                  if(dropdown) {
                    dropdown.style.maxHeight = dropdown.scrollHeight + "px";
                  }
                }
              }
            });

            // Allow keyboard to open mobile menu
            menu_item_button.addEventListener('keydown', (e) => {
              // Open menu with enter, space, up, or down arrow
              if(e.key === 'Enter' || e.key === 'Space' || e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                e.preventDefault();

                var dropdown = menu_item.querySelector(':scope > .sub-menu-container');

                if(menu_item.classList.contains('open')) {
                  menu_item.classList.remove('open');
                  menu_item_button.setAttribute('aria-expanded', 'false');

                  if(dropdown) {
                    dropdown.style.maxHeight = null;
                  }
                } else {
                  menu_item.classList.add('open');
                  menu_item_button.setAttribute('aria-expanded', 'true');

                  if(dropdown) {
                    dropdown.style.maxHeight = dropdown.scrollHeight + "px";
                  }

                  setTimeout(function(){
                    var anchors = Array.from(menu_item.querySelectorAll('ul .menu-item'));

                    anchors = anchors.filter(anchor => {
                      return !anchor.classList.contains('menu-item-overview');
                    }).map(anchor => {
                      return anchor.querySelector('a');
                    });

                    var select_anchor = anchors[0];

                    if(e.key === 'ArrowUp') {
                      select_anchor = anchors[anchors.length - 1];
                    }

                    if(select_anchor) {
                      select_anchor.focus();
                    } else {
                      menu_item.querySelector('.sub-menu-container').focus();
                    }
                  }, 350);
                }
              }
            });

            menu_item_button.addEventListener('click', (e) => {
              var dropdown = menu_item.querySelector(':scope > .sub-menu-container');

              if(document.body.classList.contains('mobile-menu-open')) {
                e.preventDefault();
                menu_item.classList.toggle('open');

                if(dropdown) {
                  dropdown.style.maxHeight = dropdown.scrollHeight + "px";
                }
              } else {
                if(menu_item.classList.contains('open')) {
                  menu_item.classList.remove('open');
                  menu_item_button.setAttribute('aria-expanded', 'false');

                  if(dropdown) {
                    dropdown.style.maxHeight = null;
                  }
                } else {
                  menu_item.classList.add('open');
                  menu_item_button.setAttribute('aria-expanded', 'true');

                  if(dropdown) {
                    dropdown.style.maxHeight = dropdown.scrollHeight + "px";
                  }

                  setTimeout(function(){
                    var anchors = menu_item.querySelector('.sub-menu-container').querySelectorAll('ul a:not(.overview-link)'),
                        select_anchor = anchors[0];

                    if(select_anchor) {
                      select_anchor.focus();
                    } else {
                      menu_item_link.parentNode.querySelector('.sub-menu-container').focus();
                    }
                  }, 350);
                }
              }
            });
          }
        }

        if(sub_menu_container) {
          var sub_menu_container_close = sub_menu_container.querySelector('.anchor-close');

          // Don't send touch event further than the container
          sub_menu_container.addEventListener('touchstart', (e) => {
            e.stopPropagation();
          }, { passive: true });

          sub_menu_container.addEventListener('keydown', (e) => {
            var anchors = Array.from(sub_menu_container.querySelectorAll(':scope > ul > li > .anchor-container a:not(.overview-link)'));

            if(anchors[0].parentNode.parentNode.classList.contains('menu-item-overview')) {
              anchors.splice(0, 1);
            }

            var current_anchor_index = anchors.indexOf(e.target);

            // On key escape
            if(e.key === 'Escape') {
              e.preventDefault();
              sub_menu_container.parentNode.classList.remove('open');
              sub_menu_container.previousElementSibling.querySelector('button').setAttribute('aria-expanded', 'false');
              sub_menu_container.previousElementSibling.querySelector('button').focus();
            }

            // On key up
            if(e.key === 'ArrowUp') {
              e.preventDefault();

              if(current_anchor_index === 0) {
                anchors[anchors.length - 1].focus();
              } else {
                anchors[current_anchor_index - 1].focus();
              }
            }

            // On key down
            if(e.key === 'ArrowDown') {
              e.preventDefault();

              if(current_anchor_index === (anchors.length - 1)) {
                anchors[0].focus();
              } else {
                anchors[current_anchor_index + 1].focus();
              }
            }

            // Key home, go to first anchor
            if(e.key === 'Home') {
              e.preventDefault();
              anchors[0].focus();
            }

            // Key end, go to last anchor
            if(e.key === 'End') {
              e.preventDefault();
              anchors[anchors.length - 1].focus();
            }
          });

          // Clear out timer if focus still in subnav.
          sub_menu_container.addEventListener('focusin', function(event){
            if (timer) {
              clearTimeout(timer);
              timer = null;
            }
          });

          // Set timer if focus leaves the subnav. This triggers even if you are tabbing within the subnav.
          sub_menu_container.addEventListener('focusout', function(event){
            timer = setTimeout(function(event){
              var open_menu_item = document.querySelector(".menu-item-has-children.open");
              if(open_menu_item && !document.body.classList.contains('mobile-menu-open')) {
                open_menu_item.classList.remove('open');
                open_menu_item.querySelector('[aria-haspopup]').setAttribute('aria-expanded', 'false');
              }
            }, 20);
          });

          if(sub_menu_container_close) {
            sub_menu_container_close.addEventListener('click', (e) => {
              e.preventDefault();

              sub_menu_container.parentNode.classList.remove('open');
              sub_menu_container.previousElementSibling.querySelector('button').setAttribute('aria-expanded', 'false');
              sub_menu_container.previousElementSibling.querySelector('button').focus();
            });
          }
        }
      });
    }
  }

  var mobile_menu_trigger = document.querySelector('.mobile-menu-trigger');
  if(mobile_menu_trigger) {
    mobile_menu_trigger.addEventListener('click', (e) => {
      e.preventDefault();

      const openMenu = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        document.body.classList.toggle('mobile-menu-open');
      };

      // Fallback for browsers that don't support View Transitions:
      if (!document.startViewTransition) {
        openMenu();
      } else {
        document.startViewTransition(() => openMenu());
      }
    });
  }
}());